import { Col, RichTextRenderer, Row, Title } from 'ui';
import { useUser } from 'features/auth';
import { Translation } from 'features/translations';

type P = {
  contentId: string;
  htmlContent?: string;
  itemType: 'kudo' | 'post' | ({} & string);
  textContent?: string;
  title?: string;
};

const ContentObjectTextContent = ({ contentId, htmlContent, itemType, textContent, title }: P) => {
  const user = useUser({ requiredAuth: false });
  const viewer = user?.railsUserData;

  if (Boolean(htmlContent) || Boolean(textContent)) {
    return (
      <Row gutter={[0, 'xs']}>
        {title ? (
          <Col span={24}>
            <Title level={5} marginBottom>
              {title}
            </Title>
          </Col>
        ) : null}
        {htmlContent ? (
          <Col span={24}>
            <RichTextRenderer data={htmlContent} />
          </Col>
        ) : null}
        {textContent ? <Col span={24}>{viewer ? <Translation id={contentId} type={itemType} /> : null}</Col> : null}
      </Row>
    );
  }

  return null;
};

export default ContentObjectTextContent;
